export const AUTH_TOKEN_NAME = "te_auth_token";
export const AUTH_MESSAGE_NAME = "te_auth_request";
export const LOGOUT_MESSAGE_NAME = "te_auth_logout_request";
export const SUCCESS_STATUS = "SUCCESS";
